// Ambient "next request's key" slot, read by the axios request interceptor
// (see api/axiosConfig.js) and written by useGuardedMutation right before it
// calls the wrapped mutation function. Consumed (read + cleared) on the very
// next outgoing request so it can never leak onto an unrelated call.

let pendingKey = null;

export function generateIdempotencyKey() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function setPendingIdempotencyKey(key) {
  pendingKey = key;
}

export function consumePendingIdempotencyKey() {
  const key = pendingKey;
  pendingKey = null;
  return key;
}
